import { Component } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { MessageService } from 'primeng/api'
import { combineLatest } from 'rxjs'
import {
    AppSettingService,
    AuthService,
    PatientService,
    RecentlyVisitedService,
    SsoService,
    UserPracticesService,
} from '../api/services'
import { CareFinitySession } from '../carefinity/services/CareFinitySession'
import { LicenseRespose } from '../api/models'
import { HttpErrorResponse } from '@angular/common/http'
import { environment } from '../../environments/environment'
import { SelectedPatientService } from '../carefinity/views/patient/patient-list/patient-service'

@Component({
    selector: 'app-saml-auth',
    templateUrl: './app.samlAuthentication.component.html',
})
export class AppSamlAuthenticationComponent {
    code: string
    error = false
    copyrightDate = ''
    public constructor(
        private userPracticesService: UserPracticesService,
        private authService: AuthService,
       private  appSettingService: AppSettingService,

        private sso: SsoService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private selectedPatientService: SelectedPatientService,
        private patientService: PatientService

    ) {
        this.code = this.activatedRoute.snapshot.queryParams['code']
        console.log('AppSamlAuthenticationComponent.logout')
        CareFinitySession.logout(authService)

        const licenseCheck: LicenseRespose =
            this.activatedRoute.snapshot.data.licenseCheck

        if (
            this.activatedRoute.snapshot.data.licenseCheck instanceof
            HttpErrorResponse
        ) {
            this.error = true
            return
        }

        if (licenseCheck.status === 'UnderConstruction') {
            this.router.navigate(['underConstruction'])
        } else if (licenseCheck.status == 'Success') {
            this.copyrightDate = environment.copyrightDate;
            // localStorage.setItem('copyrightDate', this.copyrightDate)
        } else if (licenseCheck.status == 'Warning') {
        } else if (licenseCheck.status) {
            this.router.navigate(['register'])
        } else {
            console.log(licenseCheck)
            this.error = true
            return
        }

        if (!this.code) {
            this.error = true
            this.router.navigate(['/'])
        }

        this.sso.ssoGetSamlLogin$Response({ code: this.code }).subscribe(
            (res) => {
                const authResult = res.body

                if (authResult.status != 'Success') {
                    this.error = true
                    return
                }
                debugger
                CareFinitySession.login(authResult)
                CareFinitySession.isSAMLSession = true
                CareFinitySession.showOnlyPatientNavigations = authResult.onlyPatientNav
                CareFinitySession.showPatientBanner = authResult.showDemographics

                combineLatest(
                    this.userPracticesService.userPracticesGetAllPracticesOfUser(),
                    this.authService.authAreAllQuestionsAnswered(),
                ).subscribe((r) => {
                    const [practices, questionAnswered] = r
                    localStorage.setItem('user_practices', JSON.stringify(practices))

                    if (authResult.practiceID) {
                        let prc = practices.find(
                            (x) => x.practiceid == authResult.practiceID,
                        )

                        appSettingService
                            .appSettingGetPracticeSettings$Response()
                            .subscribe({
                                next: (settings) => {
                                    CareFinitySession.selectPractice(prc, settings.body)

                                    if (authResult.patientContext) {
                                        sessionStorage.setItem(
                                            'ptId',
                                            authResult.patientContext.patientId,
                                        )
                                        sessionStorage.setItem(
                                            'ptName',
                                            authResult.patientContext.fullName,
                                        )




                                        this.patientService
                                            .patientGetPatientDetails({
                                                personId: authResult.patientContext.patientId,
                                                practiceId: localStorage.getItem('EmrPracticeId'),
                                            })
                                            .subscribe((p) => {
                                                this.selectedPatientService.changePatient({
                                                    ...authResult.patientContext,
                                                    isPatientArchived: p.isPatientArchived,
                                                })

                                                this.router.navigate(['Patient', 'dashboard']);

                                            })

                                    } else {
                                        this.router.navigate(['patient', 'patient-search'])
                                    }
                                },
                                error: (err) => {
                                    console.error(err)
                                },
                            })
                    } else {
                        this.router.navigate(['select-practice'], {
                            state: {
                                data: {
                                    context: authResult,
                                    samlLogin: true,
                                },
                            },
                        })
                    }
                })
            },
            (err) => {
                console.error(err)
            },
        )
    }
}
